(() => {
  const t = "loading-spinner";
  if (!customElements.get(t)) {
    class i extends HTMLElement {
      constructor() {
        super(), this.defaultPosition = {
          x: "right",
          y: "bottom"
        }, this.currentPosition = {
          ...this.defaultPosition
        }, this.activeSources = new Set, this.respectSiblings = !0, this.baseTransform = "", 
        this.siblingStack = {}, this.offsetStack = {}, this.offsetPriority = [], this.handleShowSpinner = this.handleShowSpinner.bind(this), 
        this.handleHideSpinner = this.handleHideSpinner.bind(this), this.handlePositionChange = this.handlePositionChange.bind(this);
      }
      connectedCallback() {
        this.setupEventListeners(), this.applyInitialPosition();
      }
      setupEventListeners() {
        document.addEventListener("spinner:show", this.handleShowSpinner), document.addEventListener("spinner:hide", this.handleHideSpinner), 
        document.addEventListener("spinner:position", this.handlePositionChange), document.addEventListener("global-ui:bottom-right-nudge", this.handlePositionChange), 
        document.addEventListener("spinner:respect-siblings", t => {
          this.respectSiblings = !1 !== t.detail.enable, this._renderTransform();
        }), document.addEventListener("loading-spinner:show", this.handleShowSpinner), document.addEventListener("loading-spinner:hide", this.handleHideSpinner);
      }
      handleShowSpinner(t) {
        const {source: i = "default", position: e, transform: s} = t.detail || {};
        this.activeSources.add(i), e && this.updatePosition(e), void 0 !== s && this._processPriorityUpdate(i, s), 
        this._evaluateVisibility(), this._renderTransform();
      }
      handleHideSpinner(t) {
        const {source: i = "default", resetPosition: e = !1} = t.detail || {};
        this.activeSources.delete(i), e && this._processPriorityUpdate(i, ""), this._evaluateVisibility(), 
        this._renderTransform();
      }
      handlePositionChange(t) {
        const {source: i = "default", transform: e, isSibling: s = !1, target: n, position: o} = t.detail || {};
        n && "loading-spinner" !== n && "all" !== n || (o && this.updatePosition(o), void 0 !== e && (s ? this._processSiblingUpdate(i, e) : this._processPriorityUpdate(i, e)), 
        this._renderTransform());
      }
      _processSiblingUpdate(t, i) {
        "" === i || null === i ? delete this.siblingStack[t] : this.siblingStack[t] = i;
      }
      _processPriorityUpdate(t, i) {
        if ("" === i || null === i) {
          delete this.offsetStack[t];
          const i = this.offsetPriority.indexOf(t);
          i > -1 && this.offsetPriority.splice(i, 1);
        } else {
          this.offsetStack[t] = i;
          const e = this.offsetPriority.indexOf(t);
          e > -1 && this.offsetPriority.splice(e, 1), this.offsetPriority.push(t);
        }
      }
      _renderTransform() {
        const t = this.baseTransform || "", i = this.respectSiblings ? Object.values(this.siblingStack).filter(t => t && "none" !== t).join(" ") : "", e = this.offsetPriority[this.offsetPriority.length - 1], s = e && this.offsetStack[e] || "", n = [ t, i, "RESET" === s || "none" === s ? "" : s ].filter(Boolean).join(" ").trim();
        this.style.transform = n || "none", this.style.transition = "transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)";
      }
      _evaluateVisibility() {
        const t = this.activeSources.size > 0;
        this.classList.toggle("hidden", !t), this.classList.toggle("block", t);
      }
      updatePosition(t) {
        const {x: i, y: e} = t;
        this.classList.remove("left-0", "right-0", "top-0", "bottom-0", "left-1/2", "top-1/2", "-translate-x-1/2", "-translate-y-1/2", "ml-offset", "mr-offset", "mt-offset", "mb-offset");
        let s = "0", n = "0";
        "center" === i ? (this.classList.add("left-1/2"), s = "-50%") : "left" === i ? this.classList.add("left-0", "ml-offset") : this.classList.add("right-0", "mr-offset"), 
        "center" === e ? (this.classList.add("top-1/2"), n = "-50%") : "top" === e ? this.classList.add("top-0", "mt-offset") : this.classList.add("bottom-0", "mb-offset"), 
        this.baseTransform = "0" !== s || "0" !== n ? `translate(${s}, ${n})` : "", this.currentPosition = {
          x: i,
          y: e
        };
      }
      applyInitialPosition() {
        this.updatePosition(this.defaultPosition);
      }
      removeEventListeners() {
        document.removeEventListener("spinner:show", this.handleShowSpinner), document.removeEventListener("spinner:hide", this.handleHideSpinner), 
        document.removeEventListener("spinner:position", this.handlePositionChange), document.removeEventListener("global-ui:bottom-right-nudge", this.handlePositionChange);
      }
    }
    customElements.define(t, i);
  }
})();